<template>
  <b-container fluid class="h-100 px-0">
    <SectionCard :headerIcon="['fas', 'star']" headerIconClass="bg-warning-orange">
      <template #header>
        <div class="d-flex w-100 align-items-center justify-content-between ml-1">
          <h6 class="m-0 font-weight-bold text-dark">Accesos Favoritos</h6>
          <p class="mb-0 fs-13 text-muted mr-1">{{activeFavorites.length}}/{{ maxFavorites }}</p>
        </div>
      </template>
      <ToolCard
        v-for="tool in activeFavorites"
        :key="tool.id"
        :tool="tool"
        :isFavorite="true"
        :canAddFavorite="true"
        @card-click="$emit('navigate', tool)"
        @toggle-fav="$emit('toggle-fav', tool.id)"
      />
      <div v-if="!activeFavorites.length" class="empty-state d-flex flex-column align-items-center justify-content-center text-center">
        <div class="text-muted mb-2">
          <font-awesome-icon :icon="['far', 'star']" size="2x" />
        </div>
        <p class="text-muted font-weight-bold mb-0 fs-19">No hay favoritos aún</p>
      </div>
    </SectionCard>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import ToolCard from './ToolCard.vue'
import SectionCard from './SectionCard.vue'

export default {
  name: 'FavoritesCard',
  components: {
    ToolCard,
    SectionCard
  },
  props: {
    activeFavorites: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(
      {
        maxFavorites: 'userPreferences/maxFavorites'
      }
    ),
  }
}
</script>

<style scoped>
.empty-state {
  grid-column: 1 / -1;
  padding: 1.5rem 0;
  height: 180px
}
</style>
